import { gql } from '@apollo/client'

import { DISH_LIST_FRAGMENT } from '../fragments'

const UPDATE_DISHES_STATUS_FLAGS_MUTATION = gql`
  mutation updateDishesStatusFlagsMutation(
    $ids: [ID!]!
    $data: StatusFlagsUpdateInput!
    $shouldOverrideTierOneCheck: Boolean
  ) {
    updateDishesStatusFlags(
      ids: $ids
      data: $data
      shouldOverrideTierOneCheck: $shouldOverrideTierOneCheck
    ) {
      ...DishListFragment
    }
  }
  ${DISH_LIST_FRAGMENT}
`

export default UPDATE_DISHES_STATUS_FLAGS_MUTATION
